import { FieldErrors, UseFormRegister } from "react-hook-form";

import SignUpFormLayout from "~/common/components/signUp/SignUpFormLayout";
import SignUpProgress from "~/common/components/signUp/SignUpProgress";
import Input from "~/common/components/ui/Input";
import { formatPhoneNumberField } from "~/common/utils/formatPhoneNumberField";
import { MobileNumberSchemaType } from "~/common/utils/signUpSchemas";
import { TeamMemberSignUpSchemaType } from "~/providers/utils/teamMemberSignUpSchema";

interface MobileNumberPageProps {
  onNext: () => Promise<void>;
  handleGoBack: () => void;
  step: number;
  totalSteps: number;
  register: UseFormRegister<TeamMemberSignUpSchemaType>;
  errors?: FieldErrors<MobileNumberSchemaType>;
  pendingRequest?: boolean;
}

export const MobileNumberPage = ({
  onNext,
  step,
  handleGoBack,
  totalSteps,
  register,
  errors,
  pendingRequest,
}: MobileNumberPageProps) => {
  return (
    <>
      <SignUpProgress step={step} totalSteps={totalSteps} />
      <SignUpFormLayout
        title="Your mobile number"
        description="You will receive a verification code via SMS."
        handleData={onNext}
        handleGoBack={handleGoBack}
        disableContinue={pendingRequest}
        pendingRequest={pendingRequest}
      >
        <Input
          id="mobile"
          label="Mobile number"
          error={errors?.phoneNumber?.message}
          {...formatPhoneNumberField<TeamMemberSignUpSchemaType>(
            "mobileNumber.phoneNumber",
            register,
          )}
        />
      </SignUpFormLayout>
    </>
  );
};
